/**
 * Truncates a string to a specified length and adds ellipsis if needed
 * @param value - The string to truncate
 * @param maxLength - Maximum length before truncation (default: 50)
 * @returns Truncated string with ellipsis if applicable
 */
export const getSubStringValue = (value: string, maxLength: number = 50): string => {
    if (!value) return '';

    let subValue = value.substring(0, maxLength);

    if (subValue.length < value.length) {
        subValue = subValue + '...';
    }

    return subValue;
};

export function stringIsEmpty(value: string | null | undefined) {
    return (value === undefined || value === null || value === "" || value.trim() === "");
}

export function objectIsNull(value: any | null | undefined) {
    return (value === undefined || value === null);
}
